import ServiceWorker from './service-worker'

export default ServiceWorker
